import React, { useRef } from 'react';
import Slider from 'react-slick';import '../../styles/transport.css'; // Import Hero specific CSS
import '../../styles/Fonts.css'; // Import Fonts specific CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css'; // Import Font Awesome
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';


const TrackOther = () => {
    const sliderRef = useRef(null); // Create a ref to control the slider

    const services = [
      { title: 'Track and Trace', 
        description: 'The system features a user-friendly interface for easy navigation. It also provides real-time status tracking to keep users informed.', 
        icon: 'fa-search-location', 
        link: 'https://rcsphtracking.com' },
  
      { title: 'Transport', 
        description: 'The fleet has GPS-monitored vehicles for secure transport. Also specialized in out-of-gauge and flat rack/flatbed transport needs.', 
        icon: 'fa-truck', 
        link: '/transport#hero' },
  
      { title: 'Forwarding', 
        description: 'We offer international and domestic air and sea services. Additionally, we provide services for specialized transport needs.', 
        icon: 'fa-shipping-fast', 
        link: '/forwarding#hero' },
  
      { title: 'Brokerage',
        description: 'We offer international and domestic air and sea services. Additionally, we provide services for specialized transport needs.', 
        icon: 'fa-user-tie', 
        link: '/brokerage#hero' },
  
      { title: 'Project', 
        description: 'We offer international and domestic air and sea services. Additionally, we provide services for specialized transport needs.', 
        icon: 'fa-project-diagram', 
        link: '/project#hero' },
        
     
    ];
  

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false, // Hide the default react-slick arrows
    autoplay: true, // Enable autoplay
    autoplaySpeed: 3000, // Set the speed (in milliseconds) for how often the slide should change
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false, // Hide arrows on smaller screens
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false, // Hide arrows on smaller screens
        }
      }
    ]
  };

  // Functions to handle prev and next clicks
  const handlePrevClick = () => {
    if (sliderRef.current) {
      sliderRef.current.slickPrev(); // Move to the previous slide
    }
  };

  const handleNextClick = () => {
    if (sliderRef.current) {
      sliderRef.current.slickNext(); // Move to the next slide
    }
  };
  return (
    <>
      <section id="services" className="py-5 services-section">
      <div className="overlay"></div>
      <div className="container">
        <div className="row-services">
          <div className="col-lg-12 d-flex align-items-center">
            <div className="my-5 text-start">
              <button disabled className="custom-button mb-4 poppins-semibold">EXPLORE MORE</button>
              <h1 className='poppins-bold text-light fs-1'>Other Services</h1>
            </div>
            <div className="arrow-btn-container d-flex ms-auto">
              {/* Custom Prev and Next buttons */}
              <button className="arrow-btn left-arrow me-3" onClick={handlePrevClick}>
                <i className="fa-solid fa-arrow-left"></i>
              </button>
              <button className="arrow-btn right-arrow" onClick={handleNextClick}>
                <i className="fa-solid fa-arrow-right"></i>
              </button>
            </div>
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-12 position-relative">
            <Slider ref={sliderRef} {...settings}>
              {services.map((service, index) => (
                <div className="services-card" key={index}>
                  <div className="card-icon">
                    <i className={`fas ${service.icon} fa-3x`}></i>
                  </div>
                  <h3 className='poppins-medium'>{service.title}</h3>
                  <p className='poppins-light'>{service.description}</p>
                  <a href={service.link} className="learn-more">Learn More <i className="fa-solid fa-circle-arrow-right"></i></a>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

export default TrackOther;
